/// <amd-module name="VSS/Redux/Modules/VSSPageData/VSSPageDataReducer" />
import { IPageData } from "VSS/Platform/Page";
import { VSSPageDataActions, VSSPageDataActionTypes } from "./VSSPageDataActions";
import produce from "immer";

export function vssPageDataReducer(state: IPageData, action: VSSPageDataActions) {
    return produce(state || null, draft => {
        switch (action.type) {
            case VSSPageDataActionTypes.InitializeVSSPageData:
                return action.payload;
        }
    });
}
